export const VALID_IMAGES = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
